/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
// 审核状态 authStatus
export const AUTH_STATUS = {
  1: { label: '待审核', value: '1' },
  2: { label: '审核通过', value: '2' },
  3: { label: '审核未通过', value: '3' }
};
// 入驻状态 status
export const IN_STATUS = {
  2: { label: '入驻项目', value: '2' },
  4: { label: '退出项目', value: '4' }
};
